export function getSentHomeRequestCreatePath(shiftId: string): string {
  return `/home-v2/myShifts/sent-home-request/create/${shiftId}`;
}
